import { AppleIcon, GoogleLoginIcon } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { saveCurrentLocationAsReturnTo } from "@/features/auth/utils/authReturnTo"

interface SocialLoginButtonsProps {
  isLoading?: boolean
  onGoogleClick?: () => void
  onAppleClick?: () => void
}

export function SocialLoginButtons({
  isLoading,
  onGoogleClick,
  onAppleClick,
}: SocialLoginButtonsProps) {
  const handleGoogleClick = () => {
    if (onGoogleClick) {
      onGoogleClick()
    } else {
      saveCurrentLocationAsReturnTo()
      window.location.href = `${import.meta.env.VITE_API_URL || ""}/auth/google`
    }
  }

  const handleAppleClick = () => {
    if (onAppleClick) {
      onAppleClick()
    } else {
      saveCurrentLocationAsReturnTo()
      window.location.href = `${import.meta.env.VITE_API_URL || ""}/auth/apple`
    }
  }

  return (
    <div className="">
      <div className="flex items-center gap-5 mb-0">
        <div className="flex-1 h-px bg-[#373433]" />
        <span className="text-sm leading-6.25 text-[#F2F0EB66]">or</span>
        <div className="flex-1 h-px bg-[#373433]" />
      </div>

      <div className="grid grid-cols-2 gap-3 mt-5 md:mt-2.5">
        <Button
          type="button"
          variant="outline"
          className="flex items-center justify-center gap-2 uppercase hover:!bg-transparent hover:!text-[#F2F0EB] hover:!border-[#F2F0EB]"
          disabled={isLoading}
          onClick={handleGoogleClick}
        >
          <GoogleLoginIcon className="!h-5 !w-5" />
          Google
        </Button>

        <Button
          type="button"
          variant="outline"
          className="flex items-center justify-center gap-2 uppercase hover:!bg-transparent hover:!text-[#F2F0EB] hover:!border-[#F2F0EB]"
          disabled={isLoading}
          onClick={handleAppleClick}
        >
          <AppleIcon className="!h-6 !w-6 mb-1" />
          Apple
        </Button>
      </div>
    </div>
  )
}
